import React, { useEffect, useMemo, useRef, useState } from 'react'
import Header from "./Header"
import BaseUrl from '../BaseUrl'
import axios from 'axios'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import swal from "sweetalert";
import Footer from './Footer';

const OTP_LENGTH = 6;

const bubbles = [
    { size: 260, left: '7%', top: '12%', opacity: 0.12, blur: 52, dur: 28, delay: -4 },
    { size: 180, left: '78%', top: '16%', opacity: 0.1, blur: 44, dur: 32, delay: -12 },
    { size: 160, left: '14%', top: '62%', opacity: 0.09, blur: 46, dur: 34, delay: -18 },
    { size: 130, left: '84%', top: '66%', opacity: 0.1, blur: 38, dur: 26, delay: -14 },
];

export default function OtpVerify() {
    const location = useLocation()
    console.log("location", location)
    const [otp, setOtp] = useState("");
    const [otpDigits, setOtpDigits] = useState(Array(OTP_LENGTH).fill(""));
    const [isVerifying, setIsVerifying] = useState(false);
    const [isResending, setIsResending] = useState(false);
    const [countdown, setCountdown] = useState(30);
    const inputRefs = useRef([]);


    const navigate = useNavigate()
    const email = location.state?.email || location.state?.data?.email || location.state?.data?.Response?.email || "";

    const primaryGradient = useMemo(
        () => ({
            backgroundImage: 'linear-gradient(90deg, #00C6FF 0%, #009BFF 40%, #0072FF 100%)',
        }),
        []
    );

    useEffect(() => {
        if (countdown <= 0) return undefined;
        const timer = setTimeout(() => setCountdown((current) => current - 1), 1000);
        return () => clearTimeout(timer);
    }, [countdown]);

    const updateOtp = (digits) => {
        const nextOtp = digits.join("");
        setOtpDigits(digits);
        setOtp(nextOtp);
    };

    const handleDigitChange = (value, index) => {
        const sanitized = value.replace(/\D/g, "");
        if (!sanitized) {
            const nextDigits = [...otpDigits];
            nextDigits[index] = "";
            updateOtp(nextDigits);
            return;
        }

        const nextDigits = [...otpDigits];
        sanitized.slice(0, OTP_LENGTH - index).split("").forEach((digit, offset) => {
            nextDigits[index + offset] = digit;
        });
        updateOtp(nextDigits);

        const nextIndex = Math.min(index + sanitized.length, OTP_LENGTH - 1);
        inputRefs.current[nextIndex]?.focus();
    };

    const handleKeyDown = (event, index) => {
        if (event.key === "Backspace" && !otpDigits[index] && index > 0) {
            inputRefs.current[index - 1]?.focus();
        }
    };

    const handlePaste = (event) => {
        event.preventDefault();
        const pastedValue = event.clipboardData.getData("text").replace(/\D/g, "").slice(0, OTP_LENGTH);
        if (!pastedValue) return;

        const nextDigits = Array(OTP_LENGTH).fill("");
        pastedValue.split("").forEach((digit, index) => {
            nextDigits[index] = digit;
        });
        updateOtp(nextDigits);
        inputRefs.current[Math.min(pastedValue.length, OTP_LENGTH) - 1]?.focus();
    };

    const sendOtp = async (e) => {
        e.preventDefault();
        if (!otp) {
            swal("Please enter your verification code.");
            return;
        }
        setIsVerifying(true);
        const token = localStorage.getItem("authorization")
        var auth = {
            headers: {
                authorization: `bearer ${token}`,
            },
        };
        const url = BaseUrl() + "api/user/verify-otp";
        const data = {
            otp: otp,

        };
        try {
            const response = await axios.post(url, data, auth);
            console.log(response)
            if (response.status === 200) {
                navigate("/change-password");
            }
            else {
                swal(response.data.message);
            }
        } catch (error) {
            swal("Invalid or expired verification code. Please try again.");
        } finally {
            setIsVerifying(false);
        }
    };

    const resendOtp = async () => {
        if (countdown > 0 || isResending) return;
        if (!email) {
            swal("Unable to resend OTP. Please go back and enter your email again.");
            return;
        }

        setIsResending(true);
        const url = BaseUrl() + 'api/user/send-otp';
        try {
            const response = await axios.post(url, { email });
            if (response.status === 200) {
                localStorage.setItem('authorization', response.data.temptoken);
                setCountdown(30);
                swal("A new verification code has been sent.", {
                    icon: "success"
                });
            } else {
                swal(response.data.message);
            }
        } catch (error) {
            swal("Unable to resend OTP. Please try again.");
        } finally {
            setIsResending(false);
        }
    };

    return (
        <div className="relative flex min-h-screen flex-col bg-[#F4FEFF]">
            <div className="relative z-20 shrink-0">
                <Header />
            </div>

            <main className="relative flex min-h-0 flex-1 flex-col overflow-hidden">
                <div
                    className="pointer-events-none absolute inset-0"
                    style={{
                        backgroundImage: [
                            'linear-gradient(105deg, #CCF4FF 0%, #E8FBFF 28%, #FFFFFF 55%, #E6F4FF 100%)',
                            'radial-gradient(620px 420px at 50% 48%, rgba(0,198,255,0.28), transparent 68%)',
                            'radial-gradient(720px 480px at 92% 24%, rgba(0,114,255,0.09), transparent 72%)',
                        ].join(','),
                    }}
                />

                {bubbles.map((bubble, index) => (
                    <span
                        key={index}
                        className="bsi-bubble pointer-events-none absolute"
                        style={{
                            width: bubble.size,
                            height: bubble.size,
                            left: bubble.left,
                            top: bubble.top,
                            opacity: bubble.opacity,
                            filter: `blur(${bubble.blur}px)`,
                            animationDuration: `${bubble.dur}s`,
                            animationDelay: `${bubble.delay}s`,
                        }}
                    />
                ))}

                <div className="relative z-10 mx-auto flex w-full max-w-6xl flex-1 flex-col items-center justify-center px-4 py-10 sm:py-12 lg:flex-row lg:items-center lg:justify-between lg:gap-10 xl:gap-14">
                    <aside className="mb-10 hidden max-w-md flex-shrink-0 lg:mb-0 lg:flex lg:flex-col lg:justify-center">
                        <div className="relative">
                            <div className="absolute -left-10 top-1/2 h-52 w-52 -translate-y-1/2 rounded-full bg-cyan-300/35 blur-3xl" />
                            <div className="absolute -right-6 top-6 h-36 w-36 rounded-full bg-[#0072FF]/22 blur-3xl" />
                            <div className="relative rounded-[28px] border border-white/85 bg-white/55 p-8 shadow-[0_28px_90px_rgba(2,132,199,0.16)] backdrop-blur-xl">
                                <div
                                    className="mb-6 inline-flex h-14 w-14 items-center justify-center rounded-2xl text-white shadow-[0_14px_34px_rgba(0,114,255,0.28)]"
                                    style={primaryGradient}
                                >
                                    <svg viewBox="0 0 24 24" className="h-7 w-7" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                                        <path d="M9 12l2 2 4-4" />
                                    </svg>
                                </div>
                                <h2 className="text-2xl font-bold tracking-tight text-[#0F172A]">Secure verification</h2>
                                <p className="mt-3 text-sm leading-relaxed text-[#64748B]">
                                    Enter the one-time code sent to your email to continue resetting your password.
                                </p>
                            </div>
                        </div>
                    </aside>

                    <div className="relative w-full max-w-[460px] shrink-0">
                        <div className="pointer-events-none absolute -inset-3 rounded-[30px] bg-gradient-to-br from-cyan-300/45 via-white/10 to-blue-400/35 opacity-90 blur-2xl" />
                        <div className="pointer-events-none absolute inset-x-10 -bottom-8 h-28 rounded-full bg-cyan-400/20 blur-2xl" />
                        <form
                            onSubmit={sendOtp}
                            className="relative rounded-[26px] border border-white/80 bg-[rgba(255,255,255,0.72)] p-7 shadow-[0_32px_100px_rgba(2,132,199,0.18)] backdrop-blur-xl sm:p-9"
                        >
                            <div className="mb-7 text-center">
                                <div
                                    className="mx-auto mb-5 inline-flex h-16 w-16 items-center justify-center rounded-3xl text-white shadow-[0_16px_38px_rgba(0,114,255,0.28)]"
                                    style={primaryGradient}
                                >
                                    <svg viewBox="0 0 24 24" className="h-8 w-8" fill="none" stroke="currentColor" strokeWidth="2">
                                        <rect x="4" y="11" width="16" height="9" rx="2" />
                                        <path d="M8 11V7a4 4 0 018 0v4" />
                                    </svg>
                                </div>
                                <h1 className="text-2xl font-bold tracking-tight text-[#0F172A] sm:text-[28px]">Verify your code</h1>
                                <p className="mt-2 text-sm leading-relaxed text-[#64748B]">
                                    Enter the verification code we sent to {email ? <span className="font-bold text-slate-800">{email}</span> : 'your email'}.
                                </p>
                            </div>

                            <input type="hidden" value={otp} required readOnly />

                            <div className="grid grid-cols-6 gap-2 sm:gap-3" onPaste={handlePaste}>
                                {otpDigits.map((digit, index) => (
                                    <input
                                        key={index}
                                        ref={(element) => {
                                            inputRefs.current[index] = element;
                                        }}
                                        type="text"
                                        inputMode="numeric"
                                        autoComplete={index === 0 ? "one-time-code" : "off"}
                                        maxLength={1}
                                        value={digit}
                                        onChange={(event) => handleDigitChange(event.target.value, index)}
                                        onKeyDown={(event) => handleKeyDown(event, index)}
                                        className="h-12 rounded-2xl border border-sky-100 bg-white/80 text-center text-xl font-extrabold text-slate-900 shadow-sm outline-none transition hover:border-sky-300 focus:border-sky-400 focus:bg-white focus:shadow-[0_0_0_4px_rgba(14,165,233,0.16)] sm:h-14"
                                        aria-label={`OTP digit ${index + 1}`}
                                    />
                                ))}
                            </div>

                            <button
                                type="submit"
                                disabled={isVerifying || !otp}
                                style={primaryGradient}
                                className="mt-7 w-full rounded-full py-3.5 text-base font-bold text-white shadow-[0_14px_38px_rgba(0,114,255,0.38)] transition duration-300 hover:scale-[1.02] hover:brightness-110 hover:shadow-[0_20px_48px_rgba(0,198,255,0.42)] active:scale-[0.98] disabled:pointer-events-none disabled:opacity-60"
                            >
                                {isVerifying ? "Verifying..." : "Verify code"}
                            </button>

                            <div className="mt-5 text-center text-sm text-[#64748B]">
                                {countdown > 0 ? (
                                    <p>Didn&apos;t receive it? <span className="font-bold text-slate-800">Resend in {countdown}s</span></p>
                                ) : (
                                    <button
                                        type="button"
                                        onClick={resendOtp}
                                        disabled={isResending}
                                        className="font-bold text-cyan-700 underline-offset-4 transition hover:text-cyan-900 hover:underline disabled:pointer-events-none disabled:opacity-60"
                                    >
                                        {isResending ? "Sending..." : "Resend OTP"}
                                    </button>
                                )}
                            </div>

                            <p className="mt-7 text-center text-sm text-[#64748B]">
                                Wrong email?{' '}
                                <Link to="/forgot-pass" className="font-bold text-cyan-700 underline-offset-4 transition hover:text-cyan-900 hover:underline">
                                    Go back
                                </Link>
                            </p>
                        </form>
                    </div>
                </div>
            </main>

            <div className="relative z-20 mt-auto shrink-0">
                <Footer />
            </div>
        </div>

    )
} 